import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Бутылка белого цвета вместимостью 500 мл выполнена из аллюминия.</p>
        <p>
          <strong>Размеры</strong><br>
          Высота (см): 20<br>
          Диаметр верх (см): 8<br>
          Диаметр низ (см): 8
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
